var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaw = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Legal-Scale--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Legal Scale Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.32 21.17a1.39 1.39 0 0 0 -1.32 -1H9a1.39 1.39 0 0 0 -1.32 1l-0.46 1.39a0.5 0.5 0 0 0 0.47 0.66h8.62a0.5 0.5 0 0 0 0.47 -0.66Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.84 12.39a0.49 0.49 0 0 0 -0.38 -0.17h-2.21A0.25 0.25 0 0 1 20 12V8.47a0.25 0.25 0 0 1 0.25 -0.25H21a1 1 0 1 0 0 -2h-7.75A0.25 0.25 0 0 1 13 6v-0.78A1.11 1.11 0 0 0 13 5a0.23 0.23 0 0 1 0 -0.21 1.49 1.49 0 0 0 0.46 -1.07 9.19 9.19 0 0 0 -1.06 -2.67 0.49 0.49 0 0 0 -0.88 0 9.19 9.19 0 0 0 -1.02 2.67 1.49 1.49 0 0 0 0.5 1.07 0.23 0.23 0 0 1 0 0.21 1.11 1.11 0 0 0 0 0.19V6a0.25 0.25 0 0 1 -0.25 0.25H3a1 1 0 1 0 0 2h0.75a0.25 0.25 0 0 1 0.25 0.22V12a0.25 0.25 0 0 1 -0.25 0.25H1.54a0.49 0.49 0 0 0 -0.38 0.17 0.49 0.49 0 0 0 -0.12 0.4 4 4 0 0 0 7.92 0 0.49 0.49 0 0 0 -0.12 -0.4 0.49 0.49 0 0 0 -0.38 -0.17H6.25A0.25 0.25 0 0 1 6 12V8.47a0.25 0.25 0 0 1 0.25 -0.25h4.5a0.25 0.25 0 0 1 0.25 0.25v7.8a0.25 0.25 0 0 1 -0.14 0.23 2.5 2.5 0 0 0 -1.36 2.22 0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.5 -0.5 2.5 2.5 0 0 0 -1.36 -2.22 0.25 0.25 0 0 1 -0.14 -0.23v-7.8a0.25 0.25 0 0 1 0.25 -0.25h4.5a0.25 0.25 0 0 1 0.25 0.25V12a0.25 0.25 0 0 1 -0.25 0.25h-2.46a0.25 0.25 0 0 0 -0.2 0.09 0.28 0.28 0 0 0 -0.08 0.21 4 4 0 0 0 8 0.27 0.49 0.49 0 0 0 -0.17 -0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaw);
export default ForwardRef;